// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Eo3t","input":"styles_input__1SpD8"};